import React, { FC, useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { fetchData, getTranslatedValue, toasterrormsg } from '../../../reusable'
import { PageTitle } from '../../../_metronic/layout/core'
import Swal from 'sweetalert2'
import { MixedWidget25 } from '../../../_metronic/partials/widgets'
import { ToastContainer } from 'react-toastify'
import Loader from '../component/Loader'
import { toAbsoluteUrl } from '../../../_metronic/helpers'
import { Tr } from '../../../_metronic/i18n/Tr'
import { useLang } from '../../../_metronic/i18n/Metronici18n'

const ViewCarRentals: FC = () => {

  const t = Tr()
  const lang = useLang()
  const navigate = useNavigate()
  const categoryId = sessionStorage.getItem('categoryId');
  useEffect(() => {
    if (categoryId != '7') {
      navigate('../dashboard/');
    }
  }, [categoryId])
  var vendorId = "";
  const vendorData = sessionStorage.getItem("vendor");
  if (vendorData) {
    var vendor = JSON.parse(vendorData);
    vendorId = vendor.vendorId;

  } else {
    console.log("No vendor data found");
  }
  const [offset, setoffset] = useState(0)
  const [limit, setlimit] = useState(9);
  const [page, setpage] = useState(1)
  const [totalPage, setTotalPage] = useState(1)
  const [from, setfrom] = useState(1)
  const [to, setTo] = useState(1)
  const [carrentalList, setCarrentalList] = useState([]);
  const [displayCarrentalList, setDisplayCarrentalList] = useState([]);
  const [pageNumbersList, setPageNumberList] = useState([1])
  const [isLoading, setIsLoading] = useState(false);

  // page number generater
  function generatePageNumbers(currentPage: any, totalPages: any, maxPagesToShow: any) {
    const halfMaxPages = Math.floor(maxPagesToShow / 2);
    let startPage = Math.max(1, currentPage - halfMaxPages);
    let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);

    // Adjust startPage and endPage if the total pages to show is less than maxPagesToShow
    if (endPage - startPage + 1 < maxPagesToShow) {
      startPage = Math.max(1, endPage - maxPagesToShow + 1);
    }

    // Generate the list of page numbers
    const pageNumbers = [];
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }

    return pageNumbers;
  }
  // on page change function
  const onpagecahnge = (pageId: any) => {
    if (pageId != page && pageId != 0 && pageId <= totalPage) {
      var tmp = (pageId - 1) * limit
      setpage(pageId)
      setoffset(tmp)
      setfrom(tmp + 1)
      // setto
      var mod = carrentalList.length % limit
      var tolimi: any = limit
      if (mod > 0) {
        if (mod <= limit) {
          tolimi = pageId * limit

        }
        else {
          tolimi = pageId * limit + limit
        }
      }
      else {
        tolimi = pageId * limit
      }
      setTo(tolimi)
      var tmpdata: any = carrentalList.slice(tmp, tolimi)
      setDisplayCarrentalList(tmpdata)
    }

  }
  //   hotel list api call
  const carrentalListAPIcall = async () => {
    setIsLoading(true)
    var param = {
      'vendorId': String(vendorId)
    }
    var res = await fetchData("public/carRentalList", param)

    if (res.status == "200") {
      setIsLoading(false)
      var data = res.data;
      setCarrentalList(data);
      var tmp: any = res.data.slice(offset, offset + limit);
      setDisplayCarrentalList(tmp)
      var totpag = (Math.ceil(res.data.length / limit))
      setTotalPage(totpag)
      if (totpag == 1) {
        var mod = res.data.length % limit
        if (mod > 0) {
          setTo(mod)
        }
        else {
          setTo(tmp.length)
        }
      }
      else {
        var mod = res.data.length % limit
        if (mod > 0) {
          setTo(page * limit + mod)
        }
        else {
          setTo(page * limit)
        }
      }

      var genpag = generatePageNumbers(page, totpag, 6)
      setPageNumberList(genpag)
    }
    else {
      toasterrormsg(res.message)
    }
  }

  //   delete hotel api call
  const confirmdelete = (carrentalId: any) => {
    Swal.fire({
      title: t('Are you sure?'),
      text: t('You Want To Delete'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: t('Yes'),
      cancelButtonText: t('No'),
    }).then(async (result) => {
      if (result.isConfirmed) {

        var param = {
          'carrentalId': String(carrentalId)
        }
        var res = await fetchData("public/deleteCarRental", param)

        if (res.status == "200") {
          carrentalListAPIcall();
        }
        else {
          toasterrormsg(res.message)
        }
      }
    });
  }

  const formatDate = (dateString: any) => {
    const options = { day: 'numeric', month: 'short', year: 'numeric' } as Intl.DateTimeFormatOptions;
    const formattedDate = new Date(dateString).toLocaleDateString('en-GB', options);
    return formattedDate;
  }
  useEffect(() => {
    carrentalListAPIcall();
  }, [])
  return (
    <>
      {isLoading && (<Loader />)}
      <ToastContainer />
      <PageTitle breadcrumbs={[]}>{t('View Car Rentals')}</PageTitle>
      <div className="d-flex justify-content-end my-2">
        <Link
          className='btn bg-white btn-active-light-primary cursor-pointer'
          id='kt_toolbar_primary_button'
          style={{ color: 'rgb(24, 28, 50)' }}
          to="../addcarrentalbasicinfo/"
        >
          + {t('Add Car Rentals')}
        </Link>
      </div>
      {/* begin::Row */}
      <div className='row g-5 g-xl-8'>
        {
          displayCarrentalList.map((carrental: any, index: any) => {
            var percentage = 0;
            if (carrental['completedSteps']['basicInfo']) {
              percentage = 10;
            }
            if (carrental['completedSteps']['location']) {
              percentage = 20;
            }
            if (carrental['completedSteps']['carRentalInfo']) {
              percentage = 40;
            }
            if (carrental['completedSteps']['photos']) {
              percentage = 50;
            }
            if (carrental['completedSteps']['insurance']) {
              percentage = 60;
            }
            if (carrental['completedSteps']['documentsRequired']) {
              percentage = 70;
            }
            if (carrental['completedSteps']['availability']) {
              percentage = 70;
            }
            if (carrental['completedSteps']['pickupDropoffInfo']) {
              percentage = 80;
            }
            if (carrental['completedSteps']['policies']) {
              percentage = 90;
            }
            if (carrental['completedSteps']['financeAndLegal']) {
              percentage = 100;
            }
            var carRentalName = getTranslatedValue(lang, carrental, '_supplierName');

            return (
              <div className='col-xl-4' key={index}>
                <MixedWidget25
                  className='card-xl-stretch mb-5 mb-xl-8'
                  color='success'
                  carrentalId={carrental['carrentalId']}
                  businessInfostatus={carrental['businessInfostatus']}
                  businessRejectReason={carrental['businessRejectReason']}
                  deleteCarRental={confirmdelete}
                  carrentalName={carRentalName}
                  image={(carrental['images'].length != 0) ? carrental['images'][0].thumbPath : toAbsoluteUrl("/media/logos/InsayrLogo.png")}
                  numberOfCars={carrental['vehcileDetail'].length}
                  pickUpAddress={carrental['pickupBranchAddress']}
                  dropOffAddress={carrental['dropoffBranchAddress']}
                  basicInsurance={carrental['isbasicInsurance']}
                  premiumInsurance={carrental['ispremiumInsurance']}
                  progress={`${percentage}%`}
                />
              </div>
            )
          })
        }
      </div>
      {/* end::Row */}
      {
        carrentalList.length == 0 && (
          <div className="d-flex flex-column flex-center text-center p-10">
            <div className="card card-flush w-100 py-5">
              <div className="card-body py-15 py-lg-20">
                <div className="fw-semibold fs-6 text-gray-500 mb-7">
                  {t('There are no records to display')}
                </div>
              </div>
            </div>
          </div>
        )
      }
      {
        carrentalList.length != 0 ? (
          <div className='d-flex flex-stack flex-wrap pt-10'>
            <div className='fs-6 fw-bold text-gray-700'>{t('Showing [from] to [to] of [total] entries').replace('[from]', String(from)).replace('[to]', String(to)).replace('[total]', String(carrentalList.length))}</div>

            <ul className='pagination'>

              <li className={`page-item previous ${page > 1 ? "" : "disabled"}`}>
                <span className={`page-link ${page > 1 ? "cursor-pointer" : "disabled"}`} onClick={() => onpagecahnge(page - 1)}>
                  <i className='previous'></i>
                </span>
              </li>
              {pageNumbersList.map((item: any, index: any) => {

                return (
                  <li className={`page-item cursor-pointer ${page == item ? "active" : ""}`} key={index}>
                    <span className='page-link' onClick={() => onpagecahnge(item)}>
                      {item}
                    </span>
                  </li>
                )
              })}

              <li className={`page-item next ${page + 1 <= totalPage ? "" : "disabled"}`}>
                <span className={`page-link ${page + 1 <= totalPage ? "cursor-pointer" : "disabled"}`} onClick={() => page + 1 <= totalPage ? onpagecahnge(page + 1) : ""}>
                  <i className='next'></i>
                </span>
              </li>
            </ul>
          </div>
        ) : ('')
      }

    </>
  )
}

export { ViewCarRentals }
